import React, { Component, Fragment } from 'react';
import { Segment, Header, Form, Grid, Loader, Button, Popup, Input } from 'semantic-ui-react';
import { fetchCountries, fetchGenderName, fetchStudyCycle } from '../../Lookups/util';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';

class ExternalStudentSendingInstitutionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countryOptions: [],
            loadingOptions: true,
            onChangeStudent: props.onChangeStudent,
            onSave: props.onSave,
            onCancel: props.onCancel,
        };
    }

    componentDidMount() {
        const axiosCallFactories =
            this.props.publicForm
                ? [
                    () => axios.get('public/external-student/countries'),
                    () => axios.get('public/external-student/study-cycles'),
                ]
                : [
                    () => fetchCountries(),
                    () => fetchStudyCycle(),
                ];
        Promise.all(axiosCallFactories.map(fn => fn()))
            .then(([countries, cycles]) => {
                this.setState({
                    countryOptions: countries.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    studyCycleOptions: cycles.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    loadingOptions: false
                });
            });
    }

    render() {
        const {
            loadingOptions,
            countryOptions,
            studyCycleOptions,
            onSave,
            onCancel,
            onChangeStudent,
        } = this.state;
        const {
            student,
            errors
        } = this.props;

        return (
            <Grid.Column>
                <Segment.Group>
                    <Segment>
                        <Header as="h3">
                            <Header.Content style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <FormattedMessage id="externalStudent.sendingInstitutionData"/>
                                {this.props.edit && !loadingOptions && (
                                    <div>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.cancel"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="cancel" basic color="red" circular
                                                             size="mini" loading={loadingOptions} onClick={onCancel}/>}
                                        />
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="check" basic color="green" circular
                                                             size="mini" loading={loadingOptions} onClick={() => {
                                                onSave(student);
                                            }}/>}
                                        />
                                    </div>
                                )}
                            </Header.Content>
                        </Header>
                    </Segment>
                    <Segment>
                        {loadingOptions ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}><Loader active inline="centered"/></div>
                        ) : (
                            <Form>
                                <Form.Field required error={errors.sendingInstitutionNameErr}>
                                    <label><FormattedMessage id="externalStudent.institutionName"/></label>
                                    <FormattedMessage id="externalStudent.enterInstitutionName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingInstitutionName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingInstitutionName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Form.Field required error={errors.sendingInstitutionFacultyNameErr}>
                                    <label><FormattedMessage id="externalStudent.institutionFaculty"/></label>
                                    <FormattedMessage id="externalStudent.enterInstitutionFaculty">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingInstitutionFacultyName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingInstitutionFacultyName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Form.Field error={errors.sendingInstitutionDepartmentErr}>
                                    <label><FormattedMessage id="externalStudent.institutionDepartment"/></label>
                                    <FormattedMessage id="externalStudent.enterInstitutionDepartment">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingInstitutionDepartment || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingInstitutionDepartment: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                {student.mobilityProgram && student.mobilityProgram.name === 'ERASMUS' &&
                                    <Popup
                                        content={<FormattedMessage id="externalStudent.erasmusCodeInfo"/>}
                                        trigger={
                                            <Form.Field error={errors.sendingInstitutionErasmusCodeErr}>
                                                <label><FormattedMessage
                                                    id="externalStudent.institutionErasmusCode"/></label>
                                                <FormattedMessage id="externalStudent.enterInstitutionErasmusCode">
                                                    {msg => (
                                                        <Input
                                                            placeholder={msg}
                                                            value={student.sendingInstitutionErasmusCode || ''}
                                                            onChange={(e, { value }) => onChangeStudent({ sendingInstitutionErasmusCode: value })}
                                                        />
                                                    )}
                                                </FormattedMessage>
                                            </Form.Field>
                                        }
                                    />
                                }
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.institutionCountry"/></label>
                                    <Form.Dropdown
                                        required
                                        search
                                        options={countryOptions}
                                        value={student.sendingInstitutionCountry || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectInstitutionCountry"/>}
                                        onChange={(e, { value }) => onChangeStudent({ sendingInstitutionCountry: value })}
                                        error={errors.sendingInstitutionCountryErr}
                                    />
                                </Form.Field>

                                <Form.Field error={errors.sendingInstitutionAddressErr}>
                                    <label><FormattedMessage id="externalStudent.institutionAddress"/></label>
                                    <FormattedMessage id="externalStudent.enterInstitutionAddress">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingInstitutionAddress || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingInstitutionAddress: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Form.Field required error={errors.sendingContactPersonFirstNameErr}>
                                    <label><FormattedMessage id="externalStudent.contactPersonFirstName"/></label>
                                    <FormattedMessage id="externalStudent.enterContactPersonFirstName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingContactPersonFirstName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingContactPersonFirstName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Form.Field required error={errors.sendingContactPersonLastNameErr}>
                                    <label><FormattedMessage id="externalStudent.contactPersonLastName"/></label>
                                    <FormattedMessage id="externalStudent.enterContactPersonLastName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingContactPersonLastName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingContactPersonLastName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Form.Field required error={errors.sendingContactPersonEmailErr}>
                                    <label><FormattedMessage id="externalStudent.contactPersonEmail"/></label>
                                    <FormattedMessage id="externalStudent.enterContactPersonEmail">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingContactPersonEmail || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingContactPersonEmail: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Form.Field error={errors.sendingContactPersonPhoneErr}>
                                    <label><FormattedMessage id="externalStudent.contactPersonPhone"/></label>
                                    <FormattedMessage id="externalStudent.enterContactPersonPhone">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.sendingContactPersonPhone || ''}
                                                onChange={(e, { value }) => onChangeStudent({ sendingContactPersonPhone: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>

                                <Popup
                                    content={<FormattedMessage id="externalStudent.studyCycleInfo"/>}
                                    trigger={
                                        <Form.Field required>
                                            <label><FormattedMessage id="externalStudent.studyCycle"/></label>
                                            <Form.Dropdown
                                                required
                                                search
                                                options={studyCycleOptions}
                                                value={student.studyCycle || null}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage id="externalStudent.selectStudyCycle"/>}
                                                onChange={(e, { value }) => onChangeStudent({ studyCycle: value })}
                                                error={errors.studyCycleErr}
                                            />
                                        </Form.Field>
                                    }
                                />
                            </Form>
                        )}
                    </Segment>
                </Segment.Group>
            </Grid.Column>
        );
    }
}

export default ExternalStudentSendingInstitutionForm;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentForms/ExternalStudentSendingInstitutionForm.js